import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { getErrorMessage } from '@/lib/errors';
import { trackingService } from '@/services/tracking.service';
import { TRACKER_KEY } from './trackerQuery';

export function useDeleteTrackerUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => trackingService.removeUser(userId),
    onSuccess: () => {
      toast.success('Person removed');
      // Stats, activity and screenshots all counted this person.
      queryClient.invalidateQueries({ queryKey: TRACKER_KEY });
    },
    onError: (e) => toast.error(getErrorMessage(e)),
  });
}
